/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./group-title.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  heading: "_11c81vhk _1rjcze3t _18zrpxbi _syaz1gjq"
};

/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */
var GroupTitle = function GroupTitle(_ref) {
  var id = _ref.id,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(Box, {
    "data-ds--menu--heading-item": true,
    role: "menuitem",
    id: id,
    "aria-hidden": "true",
    xcss: styles.heading
  }, title);
};
export default GroupTitle;